import React from 'react';

interface InfoProps {
  className?: string;
  width?: number;
  height?: number;
  onClick: (event: React.MouseEvent<SVGSVGElement>) => void;
}

const InfoIcon = function InfoIcon({
  className,
  width,
  height,
  onClick,
}: InfoProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <circle cx="12" cy="12" r="9" fill="white" stroke="#E3E3E3" />
      <path d="M12.5 7.5C12.5 7.77614 12.2761 8 12 8C11.7239 8 11.5 7.77614 11.5 7.5C11.5 7.22386 11.7239 7 12 7C12.2761 7 12.5 7.22386 12.5 7.5Z" fill="#222222" />
      <path d="M12 17V10" stroke="#222222" />
    </svg>
  );
};

InfoIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default InfoIcon;
